/* Copyright (c) 2017 Backpack Health LLC */

const ProfilePhrases = {

  myProfile: (isMainProfile, profileName) => ({
    title: {
      id: isMainProfile ? 'profile.user.title.text' : 'profile.notUser.title.text',
      values: {
        string1: profileName,
      },
    },
    deleteProfile: {
      id: 'profileDeleteConfirm.title.text',
      values: {
        string1: profileName,
      },
    },
    confirmDeleteButton: {
      id: 'profileDeleteConfirm.delete.button.label',
    },
    confirmDeleteMessage: {
      id: 'profileDeleteConfirm.delete.message.text',
    },

    birthSexLabel: {
      id: isMainProfile ? 'profile.birthSex.user.field.text' : 'profile.birthSex.notUser.field.text',
    },

    bloodTypeLabel: {
      id: isMainProfile ? 'profile.addUserBloodType.button.label' : 'profile.addNotUserBloodType.button.label',
    },

    residenceLabel: {
      id: isMainProfile ? 'profile.addUserResidence.button.label' : 'profile.addNotUserResidence.button.label',
    },

    raceLabel: {
      id: isMainProfile ? 'profile.addUserRace.button.label' : 'profile.addNotUserRace.button.label',
    },
  }),

  profileName: (isMainProfile) => ({
    title: {
      id: isMainProfile ? 'profileName.title.text' : 'profileName.dependent.title.text',
    },
    givenNameFieldLabel: {
      id: 'profileName.givenNames.button.label',
    },
    familyNameFieldLabel: {
      id: 'profileName.familyNames.button.label',
    },
    preferredNameFieldLabel: {
      id: isMainProfile ? 'profileName.preferredName.button.label' : 'profileName.dependent.preferredName.button.label',
    },
  }),

  profileSetupIntro: (isNewProfile) => ({
    title: {
      id: isNewProfile ? 'profileIntro.newUser.heading.text' : 'profileIntro.existingUser.heading.text',
    },
    helpHeading: {
      id: 'profile.newUser.helpMessage.heading',
    },
    help: {
      id: 'profile.newUser.helpMessage.text',
    },
    existingUserHelp: {
      id: 'profile.existingUser.helpMessage.text',
    },
  }),

  dependentProfileSetupIntro: (isNewProfile, profileName) => ({
    title: {
      id: isNewProfile ? 'profileIntro.newNotUser.heading.text' : 'profileIntro.existingNotUser.heading.text',
      values: {
        string1: profileName,
      },
    },
    helpHeading: {
      id: 'profile.newNotUser.helpMessage.heading',
    },
    help: {
      id: 'profile.newNotUser.helpMessage.text',
    },
    existingUserHelp: {
      id: 'profile.existingNotUser.helpMessage.text',
    },
  }),

  profileDateOfBirth: (isMainProfile) => ({
    title: {
      id: isMainProfile ? 'profileDOB.title.text' : 'profileDOB.dependent.title.text',
    },
    dateOfBirthFieldLabel: 'profileDOB.dob.field.label',
  }),

  profileGender: (isMainProfile) => ({
    title: {
      id: isMainProfile ? 'profileGender.title.text' : 'profileGender.dependent.title.text',
    },
    birthSexLabel: {
      id: isMainProfile ? 'profileGender.birthSex.field.label' : 'profileGender.dependent.birthSex.field.label',
    },
    otherOptions: {
      id: 'profileGender.otherOptions.button.label',
    },
    identifyAnotherWayLabel: {
      id: isMainProfile ? 'profileGender.otherGender.button.label' : 'profileGender.dependent.otherGender.button.label',
    },
    genderLabel: {
      id: 'profile.gender.field.label',
    },

  }),

  profileBloodType: (isMainProfile) => ({
    title: {
      id: isMainProfile ? 'bloodType.userTitle.text' : 'bloodType.notUserTitle.text',
    },
    birthSexFieldLabel: {
      id: isMainProfile ? 'profileGender.birthSex.field.label' : 'profileGender.dependent.birthSex.field.label',
    },
    otherOptions: {
      id: 'profileGender.otherOptions.button.label',
    },
    identifyAnotherWayLabel: {
      id: isMainProfile ? 'profileGender.otherGender.button.label' : 'profileGender.dependent.otherGender.button.label',
    },
  }),

  profileResidence: (isMainProfile, profileName) => {
    if (isMainProfile) {
      return {
        title: {
          id: 'profileResidence.title.user.text',
        },
      };
    } else {
      return {
        title: {
          id: 'profileResidence.title.notUser.text',
          values: { string1: profileName },
        },
      };
    }
  },

  profileRace: () => ({
    title: {
      id: 'race.title.text',
    },
    instructions: {
      id: 'race.selectionInstructions.text',
    },
    indigenous: {
      id: 'list.race.indigenous.selectName',
    },
    explanation: {
      id: 'race.explanation.text',
    },
    decline: {
      id: 'race.declineToAnswer.button.label',
    },
  }),

  profileRaceSelfIdentity: (isMainProfile) => ({
    title: {
      id: 'race.title.text',
    },
    identityLabel: {
      id: isMainProfile ? 'race.userSelfIdentify.field.label' : 'race.notUserSelfIdentify.field.label',
    },
    identityExample: {
      id: 'race.selfIdentify.examples.text',
    },
    racesLabel: {
      id: 'race.selections.label',
    },
  }),

  healthInfo: () => ({
    title: {
      id: 'profile.healthInfoConsent.title.text',
    },
  }),

  profilePrivacyConsent: () => ({
    title: {
      id: 'profilePrivacyConsent.title.text',
    },
  }),

  policyDependentAuth: () => ({
    title: {
      id: 'dependentAuth.title.text',
    },
  }),

  groupConsent: () => ({
    title: {
      id: 'profileGroupConsent.title',
    },
  }),

};

export default ProfilePhrases;
